import { useMemo } from 'react';
import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts';
import type { MenuItemConfigData } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/types.tsx';

export type GlobalShortcutsItemMap = {
	[key: string]: GlobalShortcutsItem;
};
export const useOrderedAppShortcuts = (
	shortcuts: GlobalShortcutsItemMap,
	appItemsData?: MenuItemConfigData[],
) => {
	const orderedShortcuts = useMemo(() => {
		if (!appItemsData || appItemsData.length === 0) {
			return Object.values(shortcuts);
		}

		return appItemsData.reduce<GlobalShortcutsItem[]>((acc, value) => {
			const config = shortcuts[value.menuId];
			if (config && value.visible) {
				acc.push(config);
			}
			return acc;
		}, []);
	}, [appItemsData, shortcuts]);
	return orderedShortcuts;
};
